import { sanitizeHtml } from './sanitize'
import { markdownToHtml } from './markdown'
import type { TextFormat } from './types'

export const TEXT_PROSE_CLASSES =
  "max-w-2xl text-[#374151] text-sm leading-relaxed [&_p]:mb-3 [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:mb-3 [&_ol]:list-decimal [&_ol]:pl-5 [&_ol]:mb-3 [&_a]:text-[#2563eb] [&_a]:underline [&_h1]:text-lg [&_h1]:font-semibold [&_h1]:mb-2 [&_h2]:text-base [&_h2]:font-semibold [&_h2]:mb-2 [&_h3]:text-sm [&_h3]:font-semibold [&_h3]:mb-1.5 [&_strong]:font-semibold [&_img]:max-w-full [&_img]:rounded-lg [&_code]:bg-[#f3f4f6] [&_code]:px-1 [&_code]:py-0.5 [&_code]:rounded [&_code]:text-xs [&_pre]:bg-[#f3f4f6] [&_pre]:p-3 [&_pre]:rounded-lg [&_pre]:overflow-x-auto [&_pre]:mb-3 [&_blockquote]:border-l-4 [&_blockquote]:border-[#e5e7eb] [&_blockquote]:pl-3 [&_blockquote]:text-[#6b7280] [&_blockquote]:mb-3"

// Auto-detect HTML pasted into a text module when no `format` is stored.
function looksLikeHtml(value: string): boolean {
  return /<[a-z][\s\S]*>/i.test(value)
}

// Some backends HTML-escape text on save. Decode once so saved HTML still renders (sanitized after).
function decodeIfEntityEscaped(value: string): string {
  if (!value || typeof document === 'undefined') return value
  if (/<[a-z][^>]*>/i.test(value)) return value
  if (!/&lt;[a-z][^&]*&gt;/i.test(value)) return value
  const textarea = document.createElement('textarea')
  textarea.innerHTML = value
  return textarea.value
}

export function TextContentView({
  text,
  format,
  className = TEXT_PROSE_CLASSES,
}: {
  text: string
  format?: TextFormat
  className?: string
}) {
  const value = decodeIfEntityEscaped(text || '')
  const effectiveFormat: TextFormat = format || (looksLikeHtml(value) ? 'html' : 'plain')

  if (effectiveFormat === 'markdown') {
    return <div className={className} dangerouslySetInnerHTML={{ __html: sanitizeHtml(markdownToHtml(value)) }} />
  }
  if (effectiveFormat === 'html') {
    return <div className={className} dangerouslySetInnerHTML={{ __html: sanitizeHtml(value) }} />
  }
  return <div className="max-w-2xl text-[#374151] text-sm leading-relaxed whitespace-pre-wrap">{value}</div>
}
